import { VFC } from "react";

import { DateTime } from "luxon";

import { useGetBrokerContracts } from "../hooks/useGetBrokerContracts";
import { brokerBidsIndexFilterActions } from "../store/brokerBidsIndexFilterSlice";
import { useBrokerBidsIndexSliceSelector } from "../store/brokerBidsIndexStore";
import BrokerBidsFilterBarView from "../views/BrokerBidsFilterBarView";

const BrokerBidsFilterBarContainer: VFC = () => {
  const { searchQuery, transportationMode } = useBrokerBidsIndexSliceSelector(
    (store) => store.brokerBidsIndexFilterSlice
  );
  const { fulfilledTimeStamp, refetch, isLoading } = useGetBrokerContracts();

  const setFilterState = brokerBidsIndexFilterActions.useSetFilterState();
  const lastRefreshedAt = fulfilledTimeStamp
    ? DateTime.fromMillis(fulfilledTimeStamp).toLocaleString(DateTime.TIME_WITH_SECONDS)
    : undefined;

  return (
    <BrokerBidsFilterBarView
      isLoading={isLoading}
      onChangeFilter={setFilterState}
      onRefresh={refetch}
      searchQuery={searchQuery}
      transportationMode={transportationMode}
      lastRefreshedAt={lastRefreshedAt}
    />
  );
};

export default BrokerBidsFilterBarContainer;
